module.exports = __webpack_public_path__ + "img/gl.c254fd9e.svg";